/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:35:12
 * @LastEditTime: 2022-06-16 13:33:44
 */
import Vue from "vue";
import Vuex from "vuex";
import adp from "./adp.config.js";
Vue.use(Vuex);
const store = () => {
  return new Vuex.Store({
    state: {
      SCREEN: {
        //屏幕尺寸
        mobile: false, //手机端
        width: 0, //屏幕尺寸
        conWidth: 0 //rem的值
      },
      hospital:{
        code:"H05",
        templateNo:"h05-website",
        sys:"ohealth"
      }
    },
    getters: {
      getScreen: state => {
        return state.SCREEN;
      },
      getHospital: state => {
        return state.hospital;
      },
    },
    mutations: {
      SCREEN(state, screen) {
        if (screen.width) {
          console.log(adp,screen,"====screen")
          for (let i in adp) {
            if (screen.width >= i) {
              screen.conWidth = adp[i];
            }
          }
        }
        state.SCREEN = Object.assign({}, state.SCREEN, screen);
        window.SCREEN = screen;
        console.log(screen,"====screen")
      },
      HOSPITAL(state,hospital){
        state.hospital = Object.assign({}, state.hospital, hospital)
      }
    },
    actions: {
      setScreen({ commit }, screen) {
        commit("SCREEN", screen);
      },
      setHospital({ commit }, hospital) {
        commit("HOSPITAL", hospital);
      },
    },
  });
};
export default store